import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from '../../components/Sidebar/Sidebar'
import Topbar  from '../../components/Topbar/Topbar'

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="app-shell">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="app-shell__main">
        <Topbar setSidebarOpen={setSidebarOpen} />
        <main className="app-shell__content">
          <div className="app-container">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
